import { type PayloadAction, createSlice } from '@reduxjs/toolkit';


import { type AppSelector } from '@/common/application/contextSlice';
import { hasAdminRoleInThisGroup } from '@/group/application/groupSlice';
import useGroupConvertor, { type Group } from '@/group/domain/group';

export interface AdminGroup extends Group {adminOf?: string | number }
export interface GroupsContext { list: Group[], map: { [key: string]: Group }, adminsLibrary: { [key: string]: AdminGroup } }

const initialState: GroupsContext = { adminsLibrary: {}, list: [], map: {} };

const { parentGroupId } = useGroupConvertor;

// Create a slice for groups
const holdingsSlice = createSlice({
    initialState,
    name: 'holdings',
    reducers: {
        
        // Reducer functions
        
        addAdminInLib: (state, action: PayloadAction<{key: string, group: AdminGroup}>) => {
            state.adminsLibrary[action.payload.key] = action.payload.group; 
        },
        clearHoldings: () => initialState,
        setHoldings: (state, action: PayloadAction<Group[]>) => {
            state.list = action.payload;
            state.map = {}; // Clear the map
            action.payload.forEach(item => {
                // If the group has a parent group and inherits its config, update the group config
                if (parentGroupId(item) && state.map[String(parentGroupId(item))]) {
                    const parentGroup = state.map[String(parentGroupId(item))];
                    item.groupConfig = parentGroup.groupConfig;
                }
                state.map[String(item.id)] = item;
            });
        },
    },
});

export const { setHoldings, addAdminInLib } = holdingsSlice.actions;
export default holdingsSlice.reducer;

// Update the hasAdminRoleInAnyGroup action in the groupsSlice
export const hasAdminRoleInAnyGroup = (userRef?: string): AppSelector<boolean> => (state) => {
    return (() => {
        if (!userRef) {
            return false;
        }
    
        for (const group of state.holdings) {
            
            const isAdm = hasAdminRoleInThisGroup(group.id as number)(state);
            if (isAdm) {
                return true;
            }
        }
    
        return false;
    })(); 
};